import { Unit } from '@data/unit/Unit';

/**
 * Utility to filter units by a boolean feature flag.
 * @param units List of units
 * @param featureKey Key of the feature flag in Unit
 * @return Array of units where the feature is enabled (truthy)
 */
export function unitsWithFeatureEnabled(units: Unit[], featureKey: keyof Unit): Unit[] {
	return units.filter((unit) => Boolean(unit[featureKey]));
}

/**
 * Utility to check if all units have a feature disabled.
 * @param units List of units
 * @param featureKey Key of the feature flag in Unit
 * @return True if all units have the feature disabled (falsy), otherwise false
 */
export function areAllUnitsFeatureDisabled(units: Unit[], featureKey: keyof Unit): boolean {
	return units.every((unit) => !unit[featureKey]);
}
